import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { calculateUploadedCreativeSizes } from '../../../helpers/calculateUploadedCreativeSizes'
import { gamRightUploadAdDataSelector } from '../../../../../../../../modules/selectors/rights'

import { UPLOADED_MEDIA_LIST } from '../../../fields'
import { BASE64 } from '../../../../../../../ReusableFormFields/AdFileUpload/fields'

function UploadSummary({ formik }) {
  const { t } = useTranslation()
  const { values } = formik

  const { lineItem } = useSelector(gamRightUploadAdDataSelector)

  const filledUploadedCreatives = useMemo(() => {
    return values[UPLOADED_MEDIA_LIST].filter(item => item[BASE64])
  }, [values])

  const requestedUploads = lineItem?.creative_placeholders?.length || 0

  const uploadedCreatives = useMemo(
    () => calculateUploadedCreativeSizes(filledUploadedCreatives, lineItem?.creative_placeholders),
    [filledUploadedCreatives, lineItem?.creative_placeholders]
  )

  return (
    <p>
      {t('You have uploaded {{uploadedCreatives}} out of {{requestedUploads}} supported image sizes', {
        uploadedCreatives,
        requestedUploads
      })}
      .
    </p>
  )
}

export default UploadSummary
